import { Contractor } from "@/types/contractor";

export const generateStructuredData = (contractors: Contractor[]) => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Home Pros OKC",
  "description": "Connect with verified home service professionals in Oklahoma City",
  "url": "https://homeprosokc.com",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Oklahoma City",
    "addressRegion": "OK",
    "addressCountry": "US"
  },
  "hasOfferCatalog": {
    "@type": "OfferCatalog",
    "name": "Home Services",
    "itemListElement": contractors.slice(0, 3).map((contractor) => ({
      "@type": "LocalBusiness",
      "name": contractor.name,
      "telephone": contractor.phone,
      "url": contractor.website,
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Oklahoma City",
        "addressRegion": "OK",
        "addressCountry": "US"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "35.4676",
        "longitude": "-97.5164"
      },
      "aggregateRating": contractor.rating ? {
        "@type": "AggregateRating",
        "ratingValue": contractor.rating,
        "reviewCount": contractor.review_count
      } : undefined
    }))
  }
});